/* Aweri header behaviour - extracted from sections/aweri-header.liquid (component/header-JS extraction,
   2026-06-21). The RENDER-CRITICAL bits stay as a tiny inline bootstrap in the section so they land pre-paint
   (zero FOUC): the html.aweri-stickyhdr / aweri-floatcart flags (which gate the sticky-header fix + the
   floating cart button's visibility) and the --aweri-header-h measure (the collection browse bar pins off it).
   Everything event-driven lives HERE and loads deferred, like every other aweri component. The logic is a
   verbatim move - no behaviour change. Re-queries its own DOM refs (all present after parse), so it is
   self-contained: no shared state with the bootstrap. */
(function () {
  function initHeader() {
  var hdr = document.querySelector('#aweri-header[data-aweri-header]');
  if (!hdr) return;
  var html = document.documentElement;

  // sticky header is always on (the A/B toggle is retired); the html.aweri-stickyhdr flag is set by the inline bootstrap.
  var stickyHdr = true;

  // ----- mobile chrome: the menu panel and the search bar are TWO MUTUALLY-EXCLUSIVE overlays under the fixed
  //        header. Opening one closes the other; the header never moves or auto-hides while either is open. The
  //        menu opens BELOW the header (JS sets its top) and the hamburger morphs to an X; the search bar drops
  //        below the header and closes on its toggle, a tap outside, ESC, or a scroll. -----
  var btn = hdr.querySelector('[data-aweri-menu-toggle]');
  var menu = document.querySelector('[data-aweri-mobile]');
  var msToggle = hdr.querySelector('[data-aweri-msearch-toggle]');
  var msBar = hdr.querySelector('[data-aweri-msearch]');
  var msArmed = false, msOutside = null, msEsc = null;

  function setMenu(open) {
    if (!menu) return;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      closeMsearch();                                              // mutual exclusion - never both open
      hdr.classList.remove('is-hidden');                           // the header anchors the panel, so it must be shown
      hdr.classList.add('aweri-menu-open');
      menu.style.top = hdr.getBoundingClientRect().bottom + 'px';  // open right BELOW the header (accounts for the announcement bar) so the header never moves
      menu.classList.add('is-open');
      // initialFocus = the first nav link (not a text field, so opening does NOT pop the mobile keyboard).
      if (window.AweriModal) AweriModal.open('mobile-menu', { panel: menu, opener: btn, initialFocus: menu.querySelector('a[href], summary'), onClose: function () { setMenu(false); } });
    } else {
      menu.classList.remove('is-open');
      hdr.classList.remove('aweri-menu-open');
      if (window.AweriModal) AweriModal.close('mobile-menu');
    }
  }

  function closeMsearch() {
    if (msBar && !msBar.hidden) { msBar.hidden = true; if (msToggle) msToggle.setAttribute('aria-expanded', 'false'); }
    if (msOutside) { document.removeEventListener('click', msOutside, true); msOutside = null; }
    if (msEsc) { document.removeEventListener('keydown', msEsc); msEsc = null; }
    msArmed = false;
  }
  function openMsearch() {
    if (!msBar) return;
    setMenu(false);                                                // mutual exclusion
    msBar.hidden = false;
    if (msToggle) msToggle.setAttribute('aria-expanded', 'true');
    hdr.classList.remove('is-hidden');
    var inp = msBar.querySelector('[data-aweri-search-input]'); if (inp) inp.focus();
    msArmed = false; setTimeout(function () { msArmed = true; }, 300);  // a tick before a scroll can dismiss it (the open-time keyboard scroll must not)
    msOutside = function (e) { if (msBar.contains(e.target) || (msToggle && msToggle.contains(e.target))) return; closeMsearch(); };
    msEsc = function (e) { if (e.key === 'Escape') closeMsearch(); };
    setTimeout(function () { if (msBar && !msBar.hidden) document.addEventListener('click', msOutside, true); }, 0);
    document.addEventListener('keydown', msEsc);
  }

  if (btn && menu) {
    btn.addEventListener('click', function () { setMenu(!menu.classList.contains('is-open')); });
    // A nav tap does NOT close the menu: it stays up while the next page loads, so the move reads as "from the
    // menu" (no drawer-close-then-page-moves flash). Prefetch + the top loading bar make it feel instant; the fresh
    // page renders with the menu closed, and bfcache-back closes it via AweriModal's pageshow handler.
  }
  if (msToggle && msBar) {
    msToggle.addEventListener('click', function () { if (msBar.hidden) openMsearch(); else closeMsearch(); });
  }

  // ----- inline predictive search (results drop down in place; no navigation to /search) -----
  // CODE-02: uses the shared window.AweriEscapeHtml (assets/aweri-util.js, loaded first); the inline fallback only runs if that asset failed to load.
  function esc(s) { return window.AweriEscapeHtml ? window.AweriEscapeHtml(s) : (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  // every search box: header pill, the mobile drop-down bar (both in the header), AND the drawer field (a sibling).
  var searchBoxes = [].slice.call(hdr.querySelectorAll('[data-aweri-search]'));
  if (menu) searchBoxes = searchBoxes.concat([].slice.call(menu.querySelectorAll('[data-aweri-search]')));
  searchBoxes.forEach(function (box) {
    var input = box.querySelector('[data-aweri-search-input]');
    var panel = box.querySelector('[data-aweri-search-panel]');
    if (!input || !panel) return;
    var sTimer;
    input.addEventListener('input', function () {
      clearTimeout(sTimer);
      var q = input.value.trim();
      if (q.length < 2) { panel.hidden = true; panel.innerHTML = ''; return; }
      sTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var ps = (((d.resources || {}).results || {}).products) || [];
            if (!ps.length) { panel.innerHTML = '<div class="aweri-hdr__search-empty">No matches for &ldquo;' + esc(q) + '&rdquo;</div>'; panel.hidden = false; return; }
            panel.innerHTML = ps.map(function (p) {
              var img = (p.featured_image && p.featured_image.url) || p.image || '';
              return '<a class="aweri-hdr__search-item" href="' + esc(p.url) + '">' +
                (img ? '<img src="' + esc(img) + '" alt="" width="42" height="42" loading="lazy">' : '') +
                '<span class="aweri-hdr__search-item-t">' + esc(p.title) + '</span></a>';
            }).join('') + '<a class="aweri-hdr__search-all" href="/search?q=' + encodeURIComponent(q) + '">See all results &rarr;</a>';
            panel.hidden = false;
          })
          .catch(function () { panel.hidden = true; });
      }, 220);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); var q = input.value.trim(); if (q) location.href = '/search?q=' + encodeURIComponent(q); }
      else if (e.key === 'Escape') { panel.hidden = true; }
    });
    document.addEventListener('click', function (e) { if (!box.contains(e.target)) panel.hidden = true; });
  });

  // ----- auto-hide header (down hides / up reveals) + global back-to-top button -----
  var topBtn = document.querySelector('[data-aweri-backtop]');
  if (topBtn) topBtn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); });
  var lastY = window.pageYOffset, ticking = false;
  function onScroll() {
    var y = window.pageYOffset;
    if (msArmed && msBar && !msBar.hidden) closeMsearch();         // a scroll (after the open tick) dismisses the open search bar
    var menuOpen = (menu && menu.classList.contains('is-open')) || (msBar && !msBar.hidden);  // header stays put while EITHER overlay is open (an armed search is closed by the line above first)
    if (stickyHdr && !menuOpen) {                                  // never auto-hide while the menu or the search bar is open
      if (y > lastY && y > 120) hdr.classList.add('is-hidden');   // scrolling down, past the header
      else hdr.classList.remove('is-hidden');                      // scrolling up, or near the top
    }
    // Browse v2 REWORK 2: mirror the header's hidden state onto <html>. The sticky browse bar reads this class
    // and rides an identical .32s transform - welded to the header's slide on one compositor clock (CSS, no JS).
    var nowHidden = hdr.classList.contains('is-hidden');
    html.classList.toggle('aweri-header-hidden', nowHidden);
    if (topBtn) topBtn.hidden = y < window.innerHeight * 0.7;       // back-to-top appears after ~0.7 screen
    lastY = y; ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (ticking) return; ticking = true; requestAnimationFrame(onScroll);
  }, { passive: true });
  onScroll();

  // ----- predictive prefetch (header links) + a loading bar (any internal nav) for snappy navigation -----
  var bar = document.querySelector('[data-aweri-navbar]');
  var seen = {};
  function isInternal(a) {
    return a && a.href && a.hostname === location.hostname &&
      (a.getAttribute('href') || '').charAt(0) !== '#' &&
      !a.hasAttribute('download') && a.target !== '_blank';
  }
  function prefetch(a) {
    if (!isInternal(a) || seen[a.href]) return;
    seen[a.href] = 1;
    var l = document.createElement('link'); l.rel = 'prefetch'; l.href = a.href; document.head.appendChild(l);
  }
  hdr.addEventListener('pointerenter', function (e) { var a = e.target.closest && e.target.closest('a'); if (a) prefetch(a); }, true);
  hdr.addEventListener('touchstart', function (e) { var a = e.target.closest && e.target.closest('a'); if (a) prefetch(a); }, { passive: true, capture: true });
  if (menu) {
    menu.addEventListener('pointerenter', function (e) { var a = e.target.closest && e.target.closest('a'); if (a) prefetch(a); }, true);
    menu.addEventListener('touchstart', function (e) { var a = e.target.closest && e.target.closest('a'); if (a) prefetch(a); }, { passive: true, capture: true });
  }
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var a = e.target.closest && e.target.closest('a');
    if (a && isInternal(a) && bar) { bar.classList.remove('is-loading'); void bar.offsetWidth; bar.classList.add('is-loading'); }
  });
  window.addEventListener('pageshow', function () { if (bar) bar.classList.remove('is-loading'); });
  }
  initHeader();
  // Theme editor only: re-init when the header section is re-rendered so its menu/nav stays live while editing.
  // designMode-gated => zero shopper impact; the few document/window listeners re-bound here are idempotent no-ops.
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('#aweri-header[data-aweri-header]')) initHeader();
    });
  }
})();
